<template>
  <div class="NewHome" v-loading="loading">
    <div class="training_platform_header">
      <div class="logo_wrap" v-if="screenWidth > 601">
        <img src="/static/images/homepage/zljy-logo.png" alt="" class="logo">
        <p>{{ deptName }}</p>
      </div>
      <!-- 站位用的 -->
      <div v-else></div>
      <div class="login-user">
        <div class="btn">
          <!-- <el-button @click="handleCommand('s')" v-if="userType==0">数据中心</el-button> -->
          <el-button @click="handleCommand('a')" v-if="isPlatformadmin">教务中心</el-button>
          <el-button @click="handleCommand('b')">个人中心</el-button>
          <div class="news" v-if="false">
            <div class="num">
              <span v-if="true" style="transform: scale(.9)">99</span>
              <span v-else style="transform:translateY(-4px);font-weight: bold">…</span>
            </div>
            <i class="el-icon-message"></i>
          </div>
        </div>
        <el-dropdown @command="handleCommand" :show-timeout="0">
          <div class="user-name el-dropdown-link">
            <div class="imgBox">
              <img :src="imgUrl">
            </div>
            <div class="login-name">{{ loginName }}</div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item command="a" v-if="isPlatformadmin">教务中心</el-dropdown-item>
            <el-dropdown-item command="b">个人中心</el-dropdown-item> -->
            <el-dropdown-item command="d">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- v-loading="loading" -->
    <div class="training_platform_content">
      <div class="top">
        <div class="content">
          <h3>快速入口</h3>
          <draggable v-model="quickEntrance" @update="productSort" tag="ul" v-if="quickEntrance.length>0">
            <li v-for="(item,key) in quickEntrance" :data-key="item.id" :key="key" @click="enterProduct(item)">
              <p class="product_classify">{{ item.applicationType }}</p>
              <div class="product_cover">
                <img :src="item.picurl?item.picurl:'/static/images/homepage/productCover/bg1.png'" alt="">
              </div>
              <p class="product_name">
                {{ item.name }}
                <template v-if="item.status==0">
                  <span>已过期</span>
                </template>
                <template v-if="item.status==2">
                  <span>未开通</span>
                </template>
              </p>
              <i class="product_delete el-icon-close" @click.stop="deleteProduct(item)"></i>
            </li>
          </draggable>
          <div v-else class="no_list">
            <img src="@/assets/image/sources/table_no_data.png" alt="">
            <p>将应用设为常用即可加入快速入口</p>
          </div>
        </div>
      </div>
      <div class="bot">
        <div class="content">
          <div class="all_box">
            <h3>全部应用</h3>
            <!-- <el-dropdown @command="handleTypeCommand">
						  <span class="el-dropdown-link">
						    {{ deptTypeName }}<i class="el-icon-caret-bottom el-icon--right"></i>
						  </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="0">中职</el-dropdown-item>
                <el-dropdown-item command="1">高职</el-dropdown-item>
                <el-dropdown-item command="2">本科</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->
          </div>

          <div class="major_search" v-if="false">
            <p>专业群</p>
            <ul>
              <li v-for="(item, i) in specialtyList" :key="i" :class="{active : majorCurId === i}"
                  @click="switchMajor(i,item.id)">{{ item.specialtyName }}
              </li>
            </ul>
          </div>
          <div class="classify_search">
            <p>专业分类</p>
            <ul>
              <li v-for="(item, i) in classifyList" :key="i" :class="{active : classifyCurId === i}"
                  @click="switchClassify(i)" v-if="item.status == 1">{{ item.name }}
              </li>
            </ul>
          </div>
          <div class="classify_search" v-if="false">
            <p>应用类型</p>
            <ul>
              <li v-for="(item, i) in applicationTypeIdList" :key="i" :class="{active : applicationCurId === i}"
                  @click="switchApplication(i)">{{ item.applicationType }}
              </li>
            </ul>
          </div>
          <div class="status_search" v-if="false">
            <p>开通状态</p>
            <el-select @change="switchStatus" placeholder="请选择" v-model="statusCurId"
                       style="width: 120px;margin-right: auto">
              <el-option v-for="(item, i) in statusList" :value="i" :key="i" :label="item.name"></el-option>
            </el-select>
            <el-input placeholder="请输入搜索内容"
                      style="width: 200px;"
                      v-model="searchProdName"
                      @keyup.enter.native="searchProduct">
              <div slot="suffix" style="display: flex;align-items: center;">
                <i
                  v-if="searchProdName"
                  class="el-icon-error el-input__icon"
                  style="cursor: pointer;font-size: 16px"
                  @click="handleIconClick">
                </i>
                <i
                  class="el-icon-search el-input__icon"
                  style="cursor: pointer;font-size: 22px"
                  @click="searchProduct">
                </i>
              </div>

            </el-input>
          </div>
          <ul class="product_list" v-loading="prodLoading">
            <li v-for="(item, i) in productList" :key="i">
              <div class="cover_box" @click="enterProduct(item)">
                <p class="product_classify">{{ item.applicationType }}</p>
                <img :src="item.picurl?item.picurl:'/static/images/homepage/productCover/bg1.png'" alt="">
              </div>
              <div class="product_info">
                <div class="product_info_top">
                  <h4>
                    <p :title="item.name">{{ item.name }} </p>
                    <template v-if="item.status==0">
                      <span>已过期</span>
                    </template>
                    <template v-if="item.status==2">
                      <span>未开通</span>
                    </template>
                  </h4>
                  <div class="el_switch_wrap" v-if="item.status==1">
                    <span class="label">设为常用</span>
                    <el-switch v-model="item.isFrequentlyUsed"
                               @change="isCommonlyUsed(item.isFrequentlyUsed,item.id)"></el-switch>
                  </div>
                </div>
                <div class="product_info_bot">
                  <p :title="item.briefIntroduction">{{ item.briefIntroduction }}</p>
                </div>
                <div class="product_enter" @click="enterProduct(item)">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </li>
          </ul>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pageTotal.currentPage"
            background
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageTotal.pageSize"
            :pager-count="5"
            layout="total, sizes, prev, pager, next"
            :total="pageTotal.total"
            class="new_home_pagination"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :modal="true"
      title="申请试用"
      :modal-append-to-body="true"
      :visible.sync="applyFor"
      :show-close="true"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      class="apply_dialog">
      <div class="apply_dialog_wrap">
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="姓名:" prop="name">
            <el-input type="text" v-model="ruleForm.name" autocomplete="off" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="联系电话:" prop="mobile">
            <el-input type="tel" v-model="ruleForm.mobile" autocomplete="off" placeholder="请输入联系电话"></el-input>
          </el-form-item>
          <el-form-item label="单位名称:" prop="unit_name">
            <el-input type="text" v-model="ruleForm.unit_name" autocomplete="off"
                      placeholder="请输入单位名称"></el-input>
          </el-form-item>
          <el-form-item label="您的职业:" prop="post">
            <el-input type="text" v-model="ruleForm.post" autocomplete="off" placeholder="请输入您的职业"></el-input>
          </el-form-item>
          <el-form-item label="邮箱:" prop="email">
            <el-input type="text" v-model="ruleForm.email" autocomplete="off" placeholder="请输入邮箱"></el-input>
          </el-form-item>
          <el-form-item label="备注:" prop="remark">
            <el-input type="textarea" v-model="ruleForm.remark"></el-input>
          </el-form-item>
          <div style=" text-align: center; padding-bottom: 20px">
            <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import * as api from "../api/userApi"
import {Base64} from 'js-base64';

export default {
  name: "NewHome",
  components: {
    draggable,
  },
  data() {
    var mobile = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入联系电话'));
      } else {
        callback()
      }
    };
    return {
      userId: sessionStorage.getItem('userId'),
      searchProdName: '',//用于输入的，用于搜索的产品名称
      loading: true,
      prodLoading: true,
      screenWidth: '', // 窗口大小
      sharingcenterConfigure: sessionStorage.getItem('sharingcenterConfigure'),
      routerPermissions: [],
      // imgUrl: '../../static/images/homepage/headPic.png',
      imgUrl: '../../static/images/hed0.png',
      loginName: sessionStorage.getItem('loginName'),
      userType: sessionStorage.getItem('userType'),
      quickEntrance: [],//快速入口
      classifyList: [],//应用分类
      statusList: [//开通状态
        {id: "", name: "全部"},
        {id: 1, name: "已开通"},
        {id: 2, name: "未开通"},
        {id: 0, name: "已过期"},
      ],
      classifyCurId: 0,
      statusCurId: 0,
      majorCurId: 0,
      productList: [],//全部应用
      pageTotal: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      //===================申请试用=================
      applyFor: false,
      prodName: '',//("产品分类-产品名称")
      ruleForm: {
        name: '',
        mobile: '',
        unit_name: '',
        post: '',
        email: '',
        remark: ''
      },
      rules: {
        name: [{required: true, message: '请输入姓名', trigger: 'blur'}],
        mobile: [{required: true, validator: mobile, trigger: 'blur'}],
        unit_name: [{required: true, message: '请输入单位名称', trigger: 'blur'}],
      },
      //============================================
      professional: sessionStorage.getItem('professional') ? sessionStorage.getItem('professional') : '2',//专业
      isPlatformadmin: sessionStorage.getItem('isPlatformadmin'),
      deptName: sessionStorage.getItem('deptName'),
      deptId: sessionStorage.getItem('deptId'),
      deptType: sessionStorage.getItem('deptType'),
      applicationTypeIdList: [], //应用类型
      applicationCurId: 0,
      deptTypeName: '',
      specialtyList: [], //专业大类
    };
  },
  created() {
    if (sessionStorage.getItem('routerPermissions')) {
      try {
        this.routerPermissions = JSON.parse(this.$AES.AES_Decrypt(sessionStorage.getItem('routerPermissions')))
      } catch (e) {
        console.error('NewHome.created', e)
      }
    }
    localStorage.setItem("sessionStorageConfiguration", JSON.stringify(sessionStorage))
    this.exitProduct()
  },
  mounted() {
    const userHabit = this.getStorage()
    if (typeof userHabit === 'string') {
      try {
        Object.assign(this, JSON.parse(userHabit))
      } catch (e) {
        console.log('userHabit 解析失败：', e)
      }
    }
    this.screenWidth = document.body.clientWidth;
    if (!localStorage.getItem('Authorization')) {
      this.$router.push('/')
    }
    this.getApplicationTypeIdList()
    this.getSpecialtyList()
    if (this.deptType == 0) {
      this.deptTypeName = '中职'
    } else if (this.deptType == 1) {
      this.deptTypeName = '高职'
    } else {
      this.deptTypeName = '本科'
    }
  },
  methods: {
    queryAllProdClass() {//获取应用分类
      api.queryAllProdClass({
        "deptId": this.deptId,
        "deptType": this.deptType,
        "specialtyId": this.specialtyList[this.majorCurId].id,
      }).then(rs => {
        if (rs.code == 0) {
          let newarr = [
            { className: "数字物流", classTag: "szwl", classType: 0, deptType: 1, id: 53, status: 1},
            { className: "数字商业", classTag: "xsmk", classType: 0, deptType: 1, id: 28, status: 1, },
            { className: "智能财税", classTag: "caishui", classType: 0, deptType: 1, id: 1, status: 1, },
            { className: "智慧金融", classTag: "jrkj", classType: 0, deptType: 1, id: 32, status: 1, },
          ]
          // this.classifyList = [
          //   {id: "", name: "全部", status: 1},
          // ]
          // rs.data.forEach(v => {
          newarr.forEach(v => {
            this.classifyList.push({id: v.id, name: v.className, status: v.status})
          })
        } else {
          this.$messageError(rs.msg)
        }
      }).then(() => {
        this.getCommonEntrance()
      })
    },
    getCommonEntrance() {//获取常用列表
      api.getCommonEntrance().then(rs => {
        if (rs.code == 0) {
          this.quickEntrance = rs.data
        } else {
          this.$messageError(rs.msg)
        }
      }).then(() => {
        this.getAllProd()
      })
    },
    getAllProd() {//获取全部应用
      this.setStorage()
      this.prodLoading = true
      api.getAllProd({
        "classId": this.classifyList[this.classifyCurId].id,
        "status": this.statusList[this.statusCurId].id,//转态 0过期 1开通 2关闭
        "deptType": this.deptType,
        "specialtyId": this.specialtyList[this.majorCurId].id,
        "applicationTypeId": this.applicationTypeIdList[this.applicationCurId].id,
        "prodName": this.searchProdName
      }).then(rs => {
        let newobj = {
          数字物流: [
            { "id": 254, "classId": 53, "className": "数字物流", "type": 1, "name": "仓储数据分析", "picurl": "", "tag": "ccsjfx", "briefIntroduction": "", "professional": 46, "sort": 975, "userId": null, "status": 1, "isFrequentlyUsed": false, "applicationTypeId": 2, "applicationType": "数字课程", "subjects": null },
            { "id": 255, "classId": 53, "className": "数字物流", "type": 1, "name": "运输数据分析", "picurl": "", "tag": "wlsjfx", "briefIntroduction": "", "professional": 46, "sort": 976, "userId": null, "status": 1, "isFrequentlyUsed": false, "applicationTypeId": 2, "applicationType": "数字课程", "subjects": null },
            { "id": 256, "classId": 53, "className": "数字物流", "type": 1, "name": "配送管理数据分析", "picurl": "", "tag": "psglsjfx", "briefIntroduction": "", "professional": 46, "sort": 977, "userId": null, "status": 1, "isFrequentlyUsed": false, "applicationTypeId": 2, "applicationType": "数字课程", "subjects": null },
            { "id": 257, "classId": 53, "className": "数字物流", "type": 1, "name": "供应链数据分析", "picurl": "", "tag": "gylsjfx", "briefIntroduction": "", "professional": 46, "sort": 978, "userId": null, "status": 1, "isFrequentlyUsed": false, "applicationTypeId": 2, "applicationType": "数字课程", "subjects": null },
          ],
          数字商业: [
            { "id": 259, "classId": 28, "className": "数字商业", "type": 1, "name": "市场数据分析", "picurl": "", "tag": "scsjfx", "briefIntroduction": "", "professional": 23, "sort": 980, "userId": null, "status": 1, "isFrequentlyUsed": false, "applicationTypeId": 2, "applicationType": "数字课程", "subjects": null },
            { "id": 262, "classId": 28, "className": "数字商业", "type": 1, "name": "产品数据分析", "picurl": "", "tag": "cpsjfx", "briefIntroduction": "", "professional": 23, "sort": 983, "userId": null, "status": 1, "isFrequentlyUsed": false, "applicationTypeId": 2, "applicationType": "数字课程", "subjects": null },
            { "id": 260, "classId": 28, "className": "数字商业", "type": 1, "name": "客户数据分析", "picurl": "", "tag": "khsjfx", "briefIntroduction": "", "professional": 23, "sort": 981, "userId": null, "status": 1, "isFrequentlyUsed": false, "applicationTypeId": 2, "applicationType": "数字课程", "subjects": null },
            { "id": 261, "classId": 28, "className": "数字商业", "type": 1, "name": "销售数据分析", "picurl": "", "tag": "xssjfx", "briefIntroduction": "", "professional": 23, "sort": 982, "userId": null, "status": 1, "isFrequentlyUsed": false, "applicationTypeId": 2, "applicationType": "数字课程", "subjects": null },
            { "id": 258, "classId": 28, "className": "数字商业", "type": 1, "name": "运营管理数据分析", "picurl": "", "tag": "yyglsjfx", "briefIntroduction": "", "professional": 23, "sort": 979, "userId": null, "status": 1, "isFrequentlyUsed": false, "applicationTypeId": 2, "applicationType": "数字课程", "subjects": null },
          ],
          智能财税: [
            { "id": 53, "classId": 36, "className": "会计职称", "type": 1, "name": "会计职称", "picurl": "https://zledu-oss-sx.cailian.net/cjdd/course/20220819/EF68B456-1660846824376.png", "tag": "kjzc", "briefIntroduction": "", "professional": 10, "sort": 56, "userId": null, "status": 1, "isFrequentlyUsed": false, "applicationTypeId": 2, "applicationType": "数字课程", "subjects": null },
            { "id": 16, "classId": 3, "className": "智能审计", "type": 1, "name": "智能审计-课证融通", "picurl": "https://zledu-oss-sx.cailian.net/cjdd/course/20220819/24DE555D-1660845707373.png", "tag": "szrtsj", "briefIntroduction": "将事务所真实工作任务进行教学上的转化，并进行科学化、合理化的教学设计，支撑财经专业学生技能训练。通过智能化训练，让学生掌握新技术背景下智能审计业务工作。", "professional": 1, "sort": 3, "userId": null, "status": 1, "isFrequentlyUsed": false, "applicationTypeId": 2, "applicationType": "数字课程", "subjects": null },
            { "id": 6, "classId": 9, "className": "新财经课", "type": 1, "name": "财务大数据分析实训平台", "picurl": "https://zledu-oss-sx.cailian.net/cjdd/course/20220819/5B8304B8-1660846516102.png", "tag": "cwdsjfx", "briefIntroduction": "基于财务大数据，运用大数据分析工具，从互联网获取同行业可比数据，进行行业比较分析，并进行可视化呈现。", "professional": 9, "sort": 52, "userId": null, "status": 1, "isFrequentlyUsed": false, "applicationTypeId": 2, "applicationType": "数字课程", "subjects": null },
            { "id": 106, "classId": 9, "className": "新财经课", "type": 1, "name": "智能化成本核算与管理", "picurl": "https://zledu-oss-sx.cailian.net/cjdd/course/20220819/A1488E17-1660847866371.png", "tag": "znhcbhs", "briefIntroduction": "", "professional": 9, "sort": 60, "userId": null, "status": 1, "isFrequentlyUsed": false, "applicationTypeId": 2, "applicationType": "数字课程", "subjects": null },
            { "id": 96, "classId": 9, "className": "新财经课", "type": 1, "name": "智能化税费申报与管理实训", "picurl": "https://zledu-oss-sx.cailian.net/cjdd/course/20220819/6995D0FF-1660847573428.png", "tag": "znhsfsb", "briefIntroduction": "", "professional": 9, "sort": 59, "userId": null, "status": 1, "isFrequentlyUsed": false, "applicationTypeId": 2, "applicationType": "数字课程", "subjects": null },
            { "id": 8, "classId": 9, "className": "新财经课", "type": 1, "name": "财经大数据应用基础", "picurl": "https://zledu-oss-sx.cailian.net/cjdd/course/20220819/BA7B6CE5-1660846500443.png", "tag": "cjdsjyyjc", "briefIntroduction": "基于财务大数据，运用大数据分析工具，从互联网获取同行业可比数据，进行行业比较分析，并进行可视化呈现。", "professional": 9, "sort": 53, "userId": null, "status": 1, "isFrequentlyUsed": false, "applicationTypeId": 2, "applicationType": "数字课程", "subjects": null },
          ],
          智慧金融: [
            { "id": 215, "classId": 32, "className": "智慧金融", "type": 1, "name": "供应链金融实训平台", "picurl": "https://zledu-oss-sx.cailian.net/cjdd/course/20231219/BA44B8FF-1702965017528.png", "tag": "gyljr", "briefIntroduction": "", "professional": 25, "sort": 935, "userId": null, "status": 1, "isFrequentlyUsed": false, "applicationTypeId": 2, "applicationType": "数字课程", "subjects": null },
            { "id": 119, "classId": 32, "className": "智慧金融", "type": 5, "name": "智慧金融技能竞赛平台V1.0", "picurl": "https://zledu-oss-sx.cailian.net/cjdd/course/20230630/01A77456-1688103567775.png", "tag": "jrkjjncp", "briefIntroduction": "", "professional": 25, "sort": 674, "userId": null, "status": 1, "isFrequentlyUsed": false, "applicationTypeId": 4, "applicationType": "卓越练习", "subjects": null },
            { "id": 241, "classId": 32, "className": "智慧金融", "type": 1, "name": "智慧金融赛课融通平台 V1.0", "picurl": "https://zledu-oss-sx.cailian.net/cjdd/course/20240703/CC6BAEE4-1719997970077.png", "tag": "shjrskrt", "briefIntroduction": "", "professional": 25, "sort": 966, "userId": null, "status": 1, "isFrequentlyUsed": false, "applicationTypeId": 2, "applicationType": "数字课程", "subjects": null },
          ],
        }
        let className = this.classifyList[this.classifyCurId].name
        this.productList = newobj[className]
        this.pageTotal.total = this.productList.length
        // if (rs.code == 0) {
        //   let arr = rs.data
        //   if (arr && arr.length) {
        //     arr.forEach(v => {
        //       v.isFrequentlyUsed = v.isFrequentlyUsed == 1 ? true : false
        //     })
        //     this.pageTotal.total = arr.length
        //     let start = (this.pageTotal.currentPage - 1) * this.pageTotal.pageSize
        //     let end = (this.pageTotal.currentPage - 1) * this.pageTotal.pageSize + this.pageTotal.pageSize
        //     this.productList = arr.slice(start, end)
        //   } else {
        //     this.pageTotal.total = 0
        //     this.productList = []
        //   }

        // } else {
        //   this.$messageError(rs.msg)
        // }
      }).finally(() => {
        this.prodLoading = false
        this.loading = false
      })
    },
    getApplicationTypeIdList() { //获取全部应用类型
      api.getApplicationTypeIdList().then(res => {
        if (res.code == 0) {
          this.applicationTypeIdList = [
            {id: "", applicationType: "全部"},
          ]
          res.data.forEach(v => {
            this.applicationTypeIdList.push({id: v.id, applicationType: v.applicationType})
          })
        } else {
          this.$messageError(res.msg)
        }
      })
    },
    getSpecialtyList() { //获取全部专业大类
      return api.getSpecialtyList().then(res => {
        if (res.code == 0) {
          this.specialtyList = [
            {id: "", specialtyName: "全部"},
          ]
          res.data.forEach(v => {
            this.specialtyList.push({id: v.id, specialtyName: v.specialtyName})
          })
          this.queryAllProdClass()
        } else {
          this.$messageError(res.msg)
        }
      })
    },
    deleteProduct(item) {//删除产品
      // this.$confirm("确认删除此快速入口吗?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   cancelButtonClass: "btn-custom-cancel",
      //   type: "warning"
      // }).then(() => {
      api.deleteCommonEntrance({
        "prodId": item.id
      }).then(rs => {
        if (rs.code == 0) {
          this.$messageSuccess('删除成功')
        } else {
          this.$messageError(rs.msg)
        }
      }).then(() => {
        this.loading = true
        setTimeout(() => {
          this.getCommonEntrance()
          this.getAllProd()
        }, 1000)
      })
      // })
    },
    isCommonlyUsed(val, id) {//设置是否为常用入口
      if (val) {
        api.setCommonEntrance({
          "prodId": id
        }).then(rs => {
          if (rs.code == 0) {
            this.$messageSuccess('设置成功')
          } else {
            this.$messageError(rs.msg)
          }
        }).then(() => {
          this.loading = true
          setTimeout(() => {
            this.getCommonEntrance()
            this.getAllProd()
          }, 1000)
        })
      } else {
        api.deleteCommonEntrance({
          "prodId": id
        }).then(rs => {
          if (rs.code == 0) {
            this.$messageSuccess('设置成功')
          } else {
            this.$messageError(rs.msg)
          }
        }).then(() => {
          this.loading = true
          setTimeout(() => {
            this.getCommonEntrance()
            this.getAllProd()
          }, 1000)
        })
      }
    },
    switchMajor(i, id) {//切换 专业群
      this.majorCurId = i;
      this.pageTotal.currentPage = 1;
      this.getAllProd()
      this.classifyList[0].id = ''
      this.classifyCurId = Object.is(NaN, id) ? this.classifyCurId : 0
      this.queryAllProdClass()
    },
    switchClassify(i) {//切换 专业分类
      this.classifyCurId = i;
      this.pageTotal.currentPage = 1;
      this.getAllProd()
    },
    switchStatus(i) {//切换 开通状态
      this.pageTotal.currentPage = 1;
      this.getAllProd()
    },
    switchApplication(i) { //切换 应用类型
      this.applicationCurId = i
      this.pageTotal.currentPage = 1;
      this.getAllProd()
    },
    clearStorage() {
      sessionStorage.removeItem(`NewHome_${this.userId}`)
    },
    setStorage() {// 保存用户的使用行为
      sessionStorage.setItem(`NewHome_${this.userId}`, JSON.stringify({
        deptType: this.deptType,//职业类型 中职 高职 本科
        majorCurId: this.majorCurId,//专业群
        classifyCurId: this.classifyCurId,//专业分类
        applicationCurId: this.applicationCurId,//应用类型
        statusCurId: this.statusCurId//开通状态
      }))
    },
    getStorage() { //获取用户使用行为
      return sessionStorage.getItem(`NewHome_${this.userId}`)
    },
    //分页
    handleCurrentChange(val) {
      this.pageTotal.currentPage = val;
      this.getAllProd()
    },
    handleSizeChange(val) {
      this.pageTotal.pageSize = val;
      this.pageTotal.currentPage = 1;
      this.getAllProd()
    },
    applyForDialog(item) {//申请试用
      this.applyFor = true;
      this.resetForm('ruleForm')
      this.prodName = item.className + '-' + item.name
    },
    submitForm(formName) {//保存申请
      let form = this.$refs[formName];
      this.$refs[formName].validate((valid) => {
        if (valid) {
          api.applyFor({
            email: form.model.email,
            mobile: form.model.mobile,
            name: form.model.name,
            post: form.model.post,
            remark: form.model.remark,
            unitName: form.model.unit_name,
            productName: this.prodName
          }).then((rs) => {
            if (rs.code == 0) {
              this.applyFor = false;
              this.$messageSuccess("提交成功")
            } else {
              this.$messageError(rs.msg);
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    resetForm(formName) {//清空表单
      this.$nextTick(() => {
        this.$refs[formName].resetFields();
      })
    },
    exitProduct() {
      let prodId = sessionStorage.getItem('prodId')
      if (prodId) {
        api.exitLoginNumber({
          prodId: prodId
        }).then(rs => {
          console.log(rs)
        })
      }
    },
    enterProduct(item) { //进入产品
      sessionStorage.setItem('prodClassId', item.classId)  // 选中项的id
      if (item.status == 1) {
        api.countLoginNumber({
          prodId: item.id
        }).then(rs => {
          if (rs.code == 0) {
            sessionStorage.setItem('prodId', item.id);
            sessionStorage.setItem('prodTag', item.tag);
            this.enterProductFn(item)
          } else {
            this.$messageError(rs.msg)
          }
        })
      } else {
        this.applyForDialog(item)
      }
    },
    enterProductFn(item) {

      if (this.sharingcenterConfigure) {

        let obj = {
          list: JSON.parse(this.sharingcenterConfigure),
          appFlag: "sharingcenter",
          prodId: item.id
        }
        api.newFindMenu(obj).then(rs => {
          if (rs.code == 0) {

            // 获取产品按钮权限
            if (rs.data.permissions) {
              if (sessionStorage.getItem('btnPermissions')) {
                let oldBtn = JSON.parse(this.$AES.AES_Decrypt(sessionStorage.getItem('btnPermissions')));
                let newBtn = new Set(oldBtn.concat(rs.data.permissions));
                sessionStorage.setItem('btnPermissions', this.$AES.AES_Encrypt(JSON.stringify(newBtn)));
              } else {
                sessionStorage.setItem('btnPermissions', this.$AES.AES_Encrypt(JSON.stringify(rs.data.permissions)));
              }
            }

            // 非中联机构 去掉资源库权限
            if(this.deptId != '1' && rs.data.menus && rs.data.menus[0].children.length) {
              rs.data.menus[0].children.forEach((item, i) => {
                if (item.name == '资源库') {
                  rs.data.menus[0].children.splice(i, 1)
                }
              })
            }


            // 获取产品路由权限
            let has = this.routerPermissions.filter(fitem => item.appFlag === 'sharingcenter' && fitem.arr[0].url === rs.data.menus[0].url && fitem.arr[0].type === rs.data.menus[0].type)
            let sharingcenter = {appFlag: "sharingcenter", arr: rs.data.menus}
            if (!has.length) {
              this.routerPermissions = this.routerPermissions.concat(sharingcenter);
              sessionStorage.setItem('routerPermissions', this.$AES.AES_Encrypt(JSON.stringify(this.routerPermissions)));
            }
            // else{
            //    sessionStorage.setItem('routerPermissions', this.$AES.AES_Encrypt(JSON.stringify(sharingcenter)) );
            // }
            // 跳转
            this.enterProductJump(item, rs.data.menus)
          } else {
            this.$messageError(rs.msg)
          }
        })

      } else {
        if (this.userType === '0' || this.userType === '1') {
          this.$router.push('/no-permission')
        } else {
          this.enterProductJump(item)
        }
      }
    },
    enterProductJump(item, menus) {
      this.$store.state.activeIndex = 0;

      sessionStorage.setItem('prodName', item.className + '-' + item.name)
      sessionStorage.setItem('professional', item.professional);//专业
      //productFlag - 产品内置类型：1、书证融通，2、单项训练，3、综合实训，4、真实任务，5、技能测评，6、新真实任务，7、综合实训2.0
      sessionStorage.setItem('productFlag', item.type);


      let prodTypeName = ''
      if (item.type == 1) {
        prodTypeName = '课证融通'
      } else if (item.type == 2) {
        prodTypeName = '单项训练'
      } else if (item.type == 3) {
        prodTypeName = '综合实训'
      } else if (item.type == 4) {
        prodTypeName = '真实任务'
      }
      //技能测评-新开页
      else if (item.type == 5) {
        prodTypeName = '技能测评';
        let token = localStorage.getItem('Authorization')
        // let loginInfo = sessionStorage.getItem('loginInfo').split('&')

        let subjectId = item.subjects && item.subjects.length ? item.subjects[0] : 0;


          if (menus && menus.length > 0) {
            if (menus[0].children.length > 0) {
              let sign = menus[0].children[0].url
              let tokenType = sessionStorage.getItem('tokenType')
              // loginInfo.forEach(v => {
              //   if (v.split('=')[0] === 'token_type') {
              //     tokenType = v.split('=')[1]
              //   }
              // })
              if (sign === 'JNCP_URL') {//技能测评
                let src = ''
                let teacher = ''
                let student = ''
                if (process.env.NODE_ENV === 'native' && window.g){
                   teacher = `${window.g.JNCP_URL}/#/teacherLogin?tokenType=${tokenType}&token=${token}&userType=${this.userType}&subjectId=${subjectId}`
                   student = `${window.g.JNCP_URL}/#/studentLogin?tokenType=${tokenType}&token=${token}&userType=${this.userType}&subjectId=${subjectId}`
                }else{
                   teacher = `${process.env.JNCP_URL}/#/teacherLogin?tokenType=${tokenType}&token=${token}&userType=${this.userType}&subjectId=${subjectId}`
                   student = `${process.env.JNCP_URL}/#/studentLogin?tokenType=${tokenType}&token=${token}&userType=${this.userType}&subjectId=${subjectId}`
                }

                if (this.userType === '0' || this.userType === '1') {
                  src = teacher
                } else if (this.userType === '2' || this.userType === '3') {
                  src = student
                } else {
                  this.$messageError('用户状态异常')
                }
                window.open(src)
              } else if (sign === 'DSLX_API') {//技能测评练习
                let params = {
                  token: token,
                  patternLx: 0,
                  professionId: item.professional,
                  provinceId: sessionStorage.getItem('provinceId'),
                  tag: item.tag,
                  cpName: item.name,
                  subjectId,
                  notifyUrl: window.location.href,
                  mobile: sessionStorage.getItem('mobile'),
                }
                console.log(params)
                let params_json = Base64.encode(JSON.stringify(params))
                console.log(params_json)
                let BASEURL = process.env.NODE_ENV === 'native' && window.g? window.g.DSLX_API: process.env.DSLX_API;

                if (process.env.NODE_ENV === 'sx') {
                  if (item.tag.includes('jncp') || item.tag.includes('jrkjdslx')){
                     BASEURL = process.env.NODE_ENV === 'native' && window.g? window.g.JNCP_API: process.env.JNCP_API
                  }
                }

              // let src = `${BASEURL}/#/planHome?q=${params_json}`

                window.location.href = `${BASEURL}/#/planHome?q=${params_json}`
              } else {
                this.$messageWarning('无访问权限')
              }
            } else {
              this.$messageWarning('无菜单权限')
            }
          } else {
            if (this.userType === '2' || this.userType === '3') {
              let params = {
                token: token,
                patternLx: 0,
                professionId: item.professional,
                provinceId: sessionStorage.getItem('provinceId'),
                tag: item.tag,
                cpName: item.name,
                subjectId,
                notifyUrl: window.location.href,
              }
              console.log(params)
              let params_json = Base64.encode(JSON.stringify(params))
              console.log((params_json))
              let BASEURL = process.env.DSLX_API

            if (process.env.NODE_ENV === 'sx') {
              if (item.tag.includes('jncp') || item.tag.includes('jrkjdslx')) {
                BASEURL = process.env.JNCP_API
              }
            }

            window.location.href = `${BASEURL}/#/planHome?q=${params_json}`
            // let src = `${process.env.DSLX_API}/#/planHome?q=${params_json}`
            // window.location.href = src
          } else {
            this.$messageWarning('无产品权限')
          }
        }
        return
      } else if (item.type == 6) {
        prodTypeName = '新真实任务'
        this.$store.state.cutNum = 1
      }   // 王江龙  2022.5.5 ,增加新真实任务，暂时只针对智能估值
      else if (item.type == 7) {
        prodTypeName = '综合实训2.0'
      }


      if (this.userType === '0' || this.userType === '1') {
        if (!sessionStorage.getItem('sharingcenterConfigure')) {
          this.$router.push('/no-permission')
          return
        }
        let routerArr = []
        this.routerPermissions.forEach(v => {
          if (v.appFlag === 'sharingcenter') {
            routerArr = v.arr
          }
        })
        console.log(routerArr)
        if (routerArr.length > 0) {
          let arr = []
          routerArr.forEach(v => {
            if (v.name === prodTypeName) {
              if (v.children.length > 0) {
                arr.push(v.children[0].url)
              } else {
                arr = []
              }
            }
          })

          if (arr.length > 0) {
            //审计真实任务
            if (item.type == 6 && item.professional == 1) {
              console.log(arr[0])
              this.$router.push(arr[0])
            } else {
              console.log(arr[0])
              this.$router.push(arr[0])
            }
          } else {
            this.$router.push('/no-permission')
          }
        } else {
          this.$router.push('/no-permission')
        }

      } else {
        //审计真实任务
        if ((item.type == 6 && item.professional == 1) || (item.type == 6 && item.professional == 3) || (item.type == 6 && item.professional == 2)) {
          this.$router.push('/newRealTask/Stu/ProjectTeam')
        } else {
          if(item.type == 7){//综合实训2.0
            this.$router.push('/training2')
          }else{
            this.$router.push('/n-homepage')
          }
        }
      }
    },
    productSort(evt) {//素材移动排序
      let sortArr = []
      evt.from.childNodes.forEach((item, i) => {
        sortArr.push({
          "sort": i + 1,
          "prodId": item.dataset.key
        })
      })
      api.sortUsed(sortArr).then(rs => {
        if (rs.code == 0) {
          this.getCommonEntrance()
        } else {
          this.$messageError(rs.msg)
        }
      })
    },
    //============================================================
    handleCommand(command) {//退出
      if (command === 'd') {
        this.$logOut()
      } else if (command === 'a') {
        this.$router.push('/educa')
      } else if (command === 'b') {
        this.$router.push('/settings')
      } else if (command === 's') {
        this.$router.push('/dataStatistics')
      }
    },
    handleTypeCommand(command) {
      this.deptType = command
      if (command == '1') {
        this.deptTypeName = '高职'
      } else if (command == '0') {
        this.deptTypeName = '中职'
      } else {
        this.deptTypeName = '本科'
      }
      this.getAllProd()
      this.queryAllProdClass()
    },
    handleIconClick() {
      this.searchProdName = ''
      this.getAllProd()
    },
    searchProduct() {
      this.getAllProd()
    }
  }
};
</script>
<style scoped lang="scss">
.NewHome {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background: #fff;

  .training_platform_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 56px;
    background: #FFFFFF;
    box-shadow: 0px 9px 9px 0px rgba(229, 229, 229, 0.5);

    .logo_wrap {
      height: 56px;
      display: flex;
      align-items: center;
      margin-left: 40px;

      img {
        height: 28px;
        margin-right: 15px;
      }

      p {
        font-size: 16px;
        font-weight: normal;
        line-height: 27px;
        color: #004E96;
        position: relative;
        margin-left: 25px;
        letter-spacing: 2px;
        font-weight: 600;

        &::after {
          content: '';
          position: absolute;
          left: -20px;
          top: 5px;
          width: 2px;
          height: 20px;
          background: #004E96;
        }
      }
    }

    .login-user {
      /*float: right;*/
      /*position: relative;*/
      cursor: pointer;
      display: flex;
      align-items: center;

      .login-name {
        float: left;
        margin-left: 6px;
        font-size: 18px;
        color: #3E3E3E;
        line-height: 38px;
      }

      .user-name {
        /*margin-top: 8px;*/
        margin-right: 8px;

        .imgBox {
          float: left;
          width: 38px;
          height: 38px;
          text-align: center;
          line-height: 38px;
          border: 1px solid #3E3E3E;
          border-radius: 50%;

          img {
            width: 38px;
            height: 38px;
          }
        }
      }

      .el-dropdown {
        margin-right: 32px;
      }

      .btn {
        margin-right: 15px;
        display: flex;
        align-items: center;

        .news {
          position: relative;
          margin-right: 10px;
          margin-left: 20px;

          .el-icon-message {
            font-size: 30px;
            color: #3e3e3e;
          }

          & > .num {
            width: 13px;
            height: 13px;
            border-radius: 50%;
            color: white;
            background-color: #ec5050;
            position: absolute;
            right: -7px;
            top: -5px;
            font-size: 12px;
            padding: 2px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            line-height: 0;
          }
        }

        button {
          padding: 0;
          width: 80px;
          height: 30px;
        }
      }
    }
  }

  .training_platform_content {
    height: calc(100% - 56px);
    overflow-y: auto;
    position: relative;

    .top {
      width: 100%;
      min-height: 340px;
      background: url('/static/images/homepage/top_bg.png') no-repeat;
      background-size: 100% auto;
      background-color: #F7F8FA;

      .content {
        width: 1200px;
        margin: auto;

        h3 {
          line-height: 100px;
          text-align: center;
          font-size: 24px;
          font-weight: 600;
          color: #0F0D11;
        }

        ul {
          display: flex;
          flex-wrap: wrap;

          li {
            width: 280px;
            height: 222px;
            background: #FFFFFF;
            box-shadow: 0px 6px 11px 0px rgba(172, 172, 172, 0.2200);
            border-radius: 4px;
            filter: blur(0px);
            margin-right: 20px;
            margin-bottom: 23px;
            position: relative;
            cursor: pointer;
            box-sizing: border-box;
            overflow: hidden;
            transition: .3s all;

            &:nth-child(4n) {
              margin-right: 0;
            }

            .product_classify {
              width: 81px;
              height: 33px;
              background: rgba(0, 0, 0, 0.2300);
              border-radius: 20px 4px 4px 20px;
              backdrop-filter: blur(10px);
              font-size: 14px;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 33px;
              position: absolute;
              right: 0;
              bottom: 60px;
              text-align: center;
              z-index: 999;
            }

            .product_cover {
              width: 100%;
              height: 161px;
              // margin: 30px auto 6px;

              img {
                transition: .3s;
                width: 100%;
                height: 100%;
              }
            }

            .product_name {
              font-size: 16px;
              font-weight: 600;
              color: #0F0D11;
              line-height: 64px;
              text-align: center;

              span {
                display: inline-block;
                text-align: center;
                width: 46px;
                height: 22px;
                line-height: 22px;
                background: #E6E6E6;
                border-radius: 2px;
                font-size: 12px;
                font-weight: 400;
                color: #999999;
              }
            }

            .product_delete {
              display: none;
              position: absolute;
              right: 15px;
              top: 15px;
              color: #D8D8D8;
              cursor: pointer;
            }

            &:hover {
              box-shadow: 0px 19px 33px 0px rgba(128, 125, 125, 0.21), 0 0 5px rgba(128, 125, 125, 0.21);
              transform: translateY(-10px);

              img {
                filter: contrast(105%);
              }

              .product_delete {
                display: block;
              }

              .product_name {
                color: #1890FF;
              }
            }
          }
        }

        .no_list {
          text-align: center;

          img {
            width: 186px;
          }

          p {
            font-size: 16px;
            font-weight: 400;
            color: #0F0D11;
            line-height: 16px;
            margin-top: 25px;
          }
        }
      }
    }

    .bot {
      .content {
        width: 1200px;
        margin: auto;

        .all_box {
          position: relative;

          .el-dropdown {
            position: absolute;
            top: 31px;
            right: 427px;
            cursor: pointer;
            width: 91px;
            height: 38px;
            border-radius: 22px;
            background: rgba(24, 144, 255, 0.08);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            color: rgba(24, 144, 255, 1);
          }

          h3 {
            position: relative;

            // &::after {
            //   content: "";
            //   position: absolute;
            //   width: 1px;
            //   height: 14px;
            //   right: 534px;
            //   top: 43px;
            //   background-color: #dcdfe6;
            // }
          }
        }

        h3 {
          line-height: 100px;
          text-align: center;
          font-size: 24px;
          font-weight: 600;
          color: #0F0D11;
        }

        .status_search {
          display: flex;
          align-items: center;

          .el-icon-error:hover {
            color: #ea6a6a;
          }

          .el-icon-search:hover {
            color: #007aff;
          }
        }

        .classify_search, .status_search, .major_search {
          // display: flex;
          // align-items: center;
          margin-bottom: 18px;
          min-height: 35px;

          p {
            width: 64px;
            // height: 35px;
            font-size: 16px;
            font-weight: 600;
            color: #0F0D11;
            margin-right: 20px;
            float: left;
            line-height: 35px;
          }

          ul {
            flex: 1;
            display: flex;
            flex-wrap: wrap;

            li {
              font-size: 15px;
              font-weight: 500;
              color: #595964;
              padding: 10px 20px;
              cursor: pointer;
              // margin-bottom: 5px;
            }

            .active {
              background: #1890FF;
              border-radius: 6px;
              color: #fff;
            }
          }
        }

        .product_list {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          margin-bottom: 20px;

          li {
            display: flex;
            box-sizing: border-box;
            width: 580px;
            height: 133px;
            background: #FFFFFF;
            box-shadow: 0px 2px 19px 0px rgba(110, 110, 110, 0.09);
            border-radius: 6px;
            /*margin-right: 40px;*/
            margin: 30px 0;

            /*&:nth-child(2n) {*/
            /*  margin-right: 0;*/
            /*}*/

            .cover_box {
              width: 160px;
              height: 100px;
              background: #F8FCFF;
              box-shadow: 0px 2px 9px 0px #F8F9FF;
              border-radius: 6px;
              border: 1px solid rgba(24, 144, 255, 0.1);
              filter: blur(0px);
              margin: 0 18px;
              // transform: translate(0, -20px);
              overflow: hidden;
              cursor: pointer;
              margin-top: 15px;

              img {
                width: 160px;
                height: 100px;
                // margin: 15px auto;
              }

              .product_classify {
                width: 66px;
                height: 28px;
                background: rgba(0, 0, 0, 0.2300);
                border-radius: 20px 4px 4px 20px;
                backdrop-filter: blur(10px);
                font-size: 12px;
                font-weight: 400;
                line-height: 28px;
                color: #FFFFFF;
                position: absolute;
                text-align: center;
                right: 0;
                bottom: 0;
              }
            }

            .product_info {
              flex: 1;
              position: relative;

              .product_info_top {
                display: flex;
                justify-content: space-between;
                margin-top: 13px;
                margin-bottom: 7px;
                margin-right: 21px;

                h4 {
                  font-size: 16px;
                  font-weight: 600;
                  color: #0F0D11;
                  line-height: 22px;
                  display: flex;
                  align-items: center;

                  p {
                    width: 210px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                  }

                  span {
                    text-align: center;
                    width: 46px;
                    height: 22px;
                    line-height: 22px;
                    background: #E6E6E6;
                    border-radius: 2px;
                    font-size: 12px;
                    font-weight: 400;
                    color: #999999;
                    margin-left: 5px;
                  }
                }

                .el_switch_wrap {
                  .label {
                    font-size: 12px;
                    font-weight: 400;
                    color: #42414D;
                    margin-right: 5px;
                  }

                  /deep/ .el-switch {
                    .el-switch__core {
                      background: rgba($color: #DCE0E9, $alpha: 0.49);
                      border-radius: 10px;
                      border: none;

                      &::after {
                        width: 12px;
                        height: 12px;
                        background: #BFBFC3;
                        top: 4px;
                        left: 4px;
                      }
                    }
                  }

                  /deep/ .el-switch.is-checked {
                    .el-switch__core {
                      background: rgba(24, 144, 255, 0.07);
                      border-radius: 10px;
                      border: none;

                      &::after {
                        width: 12px;
                        height: 12px;
                        background: #1890FF;
                        top: 4px;
                        left: 100%;
                      }
                    }
                  }
                }
              }

              .product_info_bot {
                p {
                  width: 367px;
                  height: 40px;
                  font-size: 12px;
                  font-weight: 400;
                  color: #42414D;
                  line-height: 20px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  word-break: break-all;
                }
              }

              .product_enter {
                width: 66px;
                height: 28px;
                background: rgba(136, 198, 255, 0.1);
                border-radius: 14px;
                position: absolute;
                right: 21px;
                bottom: 15px;
                text-align: center;
                line-height: 28px;
                cursor: pointer;

                i {
                  color: #1890FF;
                }
              }
            }

            &:hover {
              border: 1px solid #1890FF;
              box-shadow: 0px 19px 33px 0px rgba(128, 125, 125, 0.11);

              // .cover_box {
              //   transform: translate(0, -30px);
              // }

              .product_enter {
                background: linear-gradient(135deg, #1890FF 0%, #00B3F7 100%, #00B3F7 100%);

                i {
                  color: #fff;
                }
              }
            }
          }
        }
      }
    }
  }

  .new_home_pagination {
    text-align: right;
  }

  .apply_dialog {
    /deep/ .el-dialog {
      width: 500px;
      border-radius: 8px;
      overflow: hidden;

      .el-dialog__header {
        width: 100%;
        height: 48px;
        background: rgba(237, 244, 255, 1);
        padding: 20px 15px 0 15px;
        box-sizing: border-box;

        span {
          display: block;
          font-size: 14px;
          font-weight: 400;
          color: rgba(83, 151, 247, 1);
          border-left: 2px solid #5397F7;
          line-height: 10px;
          padding-left: 5px;
        }

        .el-dialog__headerbtn {
          top: 18px;
        }
      }

      .el-dialog__body {
        padding: 30px 20px 0;

        .el-form-item__label {
          line-height: 34px;
        }

        .el-form-item__content {
          line-height: 34px;

          .el-input {
            width: 300px;

            .el-input__inner {
              line-height: 34px;
              height: 34px;
            }
          }

          .el-textarea {
            width: 300px;
          }
        }
      }

      .el-dialog__footer {
        text-align: left;
        padding-top: 0;

        button {
          width: 79px;
          height: 32px;
          border: 1px solid rgba(83, 151, 247, 1);
          border-radius: 4px;
          padding: 0;
        }

        button:hover {
          background: #5397F7;
          color: #fff;
        }

        .el-button--primary:hover {
          opacity: 0.8;
        }
      }
    }
  }
}

/deep/ .el-dropdown-menu__item {
  color: #5397F7;
}

li:hover {
  background: rgba(24, 144, 255, 0.06);
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/NewHome.vue